import React, { useState } from "react";
import LastChangesTable from "./LastChangesTable";
import FieldChangesTable from "./FieldChangesTable";

const LastChangesTabs = ({
  lastChangesInfo,
  fieldNameSelected,
  setFieldNameSelected,
  getFieldChanges,
  fieldChangesInfo,
  nameFieldTab,
  setNameFieldTab,
  lastChangesRowSelected,
  setLastChangesRowSelected,
}) => {
  const [activeTab, setActiveTab] = useState("lastChanges");

  const handleTabClick = (tab) => {
    setActiveTab(tab);

    if (tab === "fieldChanges") {
      if (fieldNameSelected) {
        getFieldChanges(fieldNameSelected);
        setNameFieldTab(`${fieldNameSelected} Changes`);
      }
    } else {
      setNameFieldTab("Field Changes");
    }
  };

  //Last Changes Table
  const handleRowClick = (fieldName) => {
    setNameFieldTab(fieldName + " Changes");
    getFieldChanges(fieldName);

    // Activate the Field Changes tab
    document.getElementById("fieldChanges-tab").classList.add("active");
    document.getElementById("lastChanges-tab").classList.remove("active");

    document.getElementById("fieldChanges").classList.add("active", "show");
    document.getElementById("lastChanges").classList.remove("active", "show");
  };

  return (
    <div className="col mt-3 mb-4">
      <ul className="nav nav-tabs" id="lastChangesTab" role="tablist">
        <li className="nav-item">
          <a
            className={`nav-link ${
              activeTab === "lastChanges" ? "active" : ""
            }`}
            id="lastChanges-tab"
            data-toggle="tab"
            href="#lastChanges"
            role="tab"
            aria-controls="lastChanges"
            aria-selected={activeTab === "lastChanges"}
            onClick={(e) => {
              e.preventDefault();
              handleTabClick("lastChanges");
            }}
          >
            Last Changes
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${
              activeTab === "fieldChanges" ? "active" : ""
            }`}
            id="fieldChanges-tab"
            data-toggle="tab"
            href="#fieldChanges"
            role="tab"
            aria-controls="fieldChanges"
            aria-selected={activeTab === "fieldChanges"}
            onClick={(e) => {
              e.preventDefault();
              handleTabClick("fieldChanges");
            }}
          >
            {nameFieldTab}
          </a>
        </li>
      </ul>

      <div className="tab-content" id="lastChangesTabContent">
        <div
          className={`tab-pane fade ${
            activeTab === "lastChanges" ? "show active" : ""
          }`}
          id="lastChanges"
          role="tabpanel"
          aria-labelledby="lastChanges-tab"
        >
          <LastChangesTable
            lastChangesInfo={lastChangesInfo}
            setFieldNameSelected={setFieldNameSelected}
            lastChangesRowSelected={lastChangesRowSelected}
            setLastChangesRowSelected={setLastChangesRowSelected}
            handleRowClick={handleRowClick}
          />
        </div>

        <div
          className={`tab-pane fade ${
            activeTab === "fieldChanges" ? "show active" : ""
          }`}
          id="fieldChanges"
          role="tabpanel"
          aria-labelledby="fieldChanges-tab"
        >
          <FieldChangesTable fieldChangesInfo={fieldChangesInfo} />
        </div>
      </div>
    </div>
  );
};

export default LastChangesTabs;
